export function formatValue(value, format, unit = "") {
  if (value == null || isNaN(value)) return "—";
  if (format === "currency") {
    if (Math.abs(value) >= 1000)
      return "$" + value.toLocaleString("en-US", { maximumFractionDigits: 0 });
    return "$" + value.toFixed(2);
  }
  if (format === "percent") return value.toFixed(2) + "%";
  return value.toLocaleString("en-US", { maximumFractionDigits: 0 }) + unit;
}

export function formatChange(change) {
  const sign = change > 0 ? "+" : "";
  return sign + change.toFixed(2) + "%";
}
